<section class="custom-modal-container"
         [ngStyle]="{'width': modalConfig.width, 'height': modalConfig.height, 'top': modalConfig.top, 'left': modalConfig.left, 'right': modalConfig.right}"
         [hidden]="!showModal">
    <div class="custom-modal">
        <header #CustomDragger class="cm-cabecera">
            <h1 class="cm-title">{{titulo}}</h1>
            <button mat-icon-button class="" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </header>
        <div class="cm-contenido">
            <div class="cont">
                <div #contenedorDinamico></div>
            </div>
        </div>
    </div>
</section>